export default [
    { value: 0, label: 'OnPrem' },
    { value: 1, label: 'Azure' },
  ];
